const configured = (process.env.REACT_APP_MARKETPLACE_MODE || "free").trim().toLowerCase();

export const MARKETPLACE_MODE = configured === "subscription" ? "subscription" : "free";
export const MARKETPLACE_IS_FREE = MARKETPLACE_MODE === "free";
export const BILLING_ENABLED = MARKETPLACE_MODE === "subscription";
